module.exports = __webpack_public_path__ + "img/0020.2962f3f1.jpg";